import request from '@/utils/request'; // 获取楼宇层级树(areagroupId)

export function fetchTreeList(data) {
  return request({
    url: '/pmsservice/api/pmsTree/selectPmsTree',
    method: 'post',
    data: data
  });
} // 获取楼宇层级树(areaId)

export function fetchTree(data) {
  return request({
    url: '/pmsservice/api/pmsTree/selectPmsTreeWithArea',
    method: 'post',
    data: data
  });
}
export function selectPmsTreeNumber(data) {
  return request({
    url: '/pmsservice/api/pmsTree/selectPmsTreeNumber',
    method: 'post',
    data: data
  });
}
export function selectManagerArea() {
  return request({
    url: '/pmsservice/api/area/selectManagerArea',
    method: 'post'
  });
}
export function selectAreaClassify(data) {
  return request({
    url: '/pmsservice/api/area/selectAreaClassify',
    method: 'post',
    data: data
  });
} // 获取楼宇树

export function selectAreaCityNode(data) {
  return request({
    url: '/pmsservice/api/pmsTree/selectAreaCityNode',
    method: 'post',
    data: data
  });
}